import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import ImageIcon from 'components/ImageIcon';
import cn from 'classnames';
import css from './GroupedLinksBlock.module.scss';
import GroupWithLinksBlock from 'components/GroupWithLinksBlock/GroupWithLinksBlock';
import { THEMES, getThemeClassNames } from 'constants/themes';

class GroupedLinksBlock extends React.Component {
    static propTypes = {
        heading: PropTypes.string.isRequired,
        text: PropTypes.string,
        items:PropTypes.arrayOf(PropTypes.shape(GroupWithLinksBlock.propTypes)),
        icon: PropTypes.string,
        iconNew: PropTypes.shape(ImageIcon.propTypes),
        theme: PropTypes.oneOf(Object.values(THEMES)),
        blockId: PropTypes.number,
    };

    static defaultProps = {
        theme: 0
    }

    render() {
        const {
            heading,
            text,
            items,
            theme,
            icon,
            iconNew,
            blockId,
        } = this.props;

        const classNames = cn(css.block, {
            ...getThemeClassNames(css, theme),
        });

        return (
            <div
                className={classNames}
                data-block={blockId}
            >
                <div className={css['block-content']}>
                    <div className={css['list-content']}>
                        {iconNew ? (
                            <div className={css.icon}>
                                <ImageIcon {...iconNew} />
                            </div>
                        ) : 
                            (icon ? (
                                <div className={css.icon}><Icon icon={icon} /></div>
                            ) : null)
                        }
                        {heading && <h2 className={css.heading}>{heading}</h2>}
                        {text && <p className={css.text}>{text}</p>}
                        {items && (
                            <ul className={css.list}>
                                {items.map((item, index) => (
                                    <li key={index} className={css.listItem}>
                                        <GroupWithLinksBlock 
                                            {...item} 
                                            theme={theme}  
                                            headingTagLevel={heading ? 3 : 2}
                                        />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default GroupedLinksBlock;


// WEBPACK FOOTER //
// ./src/components/GroupedLinksBlock/GroupedLinksBlock.jsx